import { gsap } from 'gsap'
import { CSSRulePlugin } from 'gsap/CSSRulePlugin'
import { GSDevTools } from 'gsap/GSDevTools'

const lib = require('../library')
const prod = process.env.NODE_ENV === 'production'

gsap.registerPlugin(CSSRulePlugin, GSDevTools)

export default class InlinePanels {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.nav = this.el.querySelectorAll('[data-panel-trigger]')
    this.container = this.el.querySelector('[data-panel-container]')
    this.activeCls = 'block'
    this.hiddenCls = 'hidden'
    this.activeHeight = ''
    this.sequenceSelector = '[data-sequence]'
    this.activeId = 1
  }

  init() {
    this.nav.forEach((trigger) => {
      trigger.addEventListener('click', this.handleNav)
    })
  }

  handleNav = (event) => {
    event.preventDefault()
    let clickedId = event.target.dataset.panelTrigger
    if (!clickedId) {
      clickedId = event.target.parentElement.dataset.panelTrigger
    }
    if (clickedId === this.activeId) {
      return false
    }
    const next = this.getElementById(clickedId)
    const current = this.getElementById(this.activeId)
    this.activeId = clickedId
    this.handleTransition(current, next)
  }

  handleTransition(current, next) {
    if (!current || !next) {
      return false
    }
    const currentHeight = lib.getHeight(current)
    const nextHeight = lib.getHeight(next)
    const tlSlideChange = gsap.timeline({
      duration: 0.15,
      ease: 'power2.inOut',
    })
    // figure out if we have children to sequence out and in
    const sequenceIn = next.querySelectorAll(this.sequenceSelector)

    // fade out current element
    tlSlideChange.fromTo(
      current,
      {
        opacity: 1,
      },
      {
        opacity: 0,
      },
      '<',
    )

    // change height of container
    tlSlideChange.fromTo(
      this.container,
      { height: currentHeight },
      {
        height: nextHeight,
      },
      '-=<.1',
    )
    this.handleClsSwap(current, next)
    if (sequenceIn.length) {
      let duration = 1 / sequenceIn.length
      if (duration < 0.09) {
        duration = 0.09
      } else if (duration > 0.3) {
        duration = 0.3
      }
      tlSlideChange.fromTo(
        sequenceIn,
        {
          opacity: 0,
          y: '-=30',
        },
        { opacity: 1, y: 0, stagger: duration },
        '-=<.1',
      )
    }
    tlSlideChange.fromTo(
      next,
      { opacity: 0 },
      {
        opacity: 1,
      },
      '-=<.1',
    )
  }

  handleClsSwap(current, next) {
    current.classList.add(this.hiddenCls)
    current.classList.remove(this.activeCls)
    next.classList.add(this.activeCls)
    next.classList.remove(this.hiddenCls)
  }

  getElementById(id) {
    return this.el.querySelector(`[data-panel="${id}"]`)
  }
}
